<template>

  <!-- Edit Schedule Modal -->
  <div :id="id" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Attentance</h5>
          <button type="button" ref="Close" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" >
          <div v-if="attendanceDetails?.is_manually_edited" class="alert alert-info py-2 px-3 mb-3 d-flex align-items-center" style="font-size: 0.85rem;">
            <i class="fas fa-info-circle me-2"></i>
            <div>
              <span>Last updated </span>
              <span v-if="attendanceDetails.updated_by_user">
                by <strong>{{ attendanceDetails.updated_by_user.first_name }} {{ attendanceDetails.updated_by_user.last_name }}</strong>
              </span>
              <span v-else-if="attendanceDetails.updated_by">
                by <strong>{{ attendanceDetails.updated_by }}</strong>
              </span>
              <span v-if="attendanceDetails.updated_at">
                at <strong>{{ formatDateTime(attendanceDetails.updated_at) }}</strong>
              </span>
              <span v-if="attendanceDetails.reason">
                <br/><small class="text-muted">Reason: {{ attendanceDetails.reason }}</small>
              </span>
            </div>
          </div>
          <div >
          <form @submit.prevent="submit()">
            <div class="row  mt-1 ">

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Start Time <span class="text-danger">*</span></label>
                  <div class="input-group time">
                    <input type="text" maxlength="8" @keydown="handleTimeKeydown($event, $data, 'startTime')" v-model="startTime" class="form-control timepicker" placeholder="00:00:00" />
                    <span class="input-group-text"><i class="fa-regular fa-clock"></i></span>
                  </div>
                </div>
              </div>


              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">End Time <span class="text-danger">*</span></label>
                  <div class="input-group time">
                    <input type="text" maxlength="8" @keydown="handleTimeKeydown($event, $data, 'endTime')" v-model="endTime" class="form-control timepicker" placeholder="00:00:00" />
                    <span class="input-group-text"><i class="fa-regular fa-clock"></i></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="input-block mb-3">
              <label class="col-form-label"
                >Reason<span class="text-danger">*</span></label
              >
              <textarea rows="2" v-model="reason" class="form-control"></textarea>
            </div>

            <div class="submit-section">
              <button type="submit" class="btn btn-primary submit-btn">
                <span v-if="!loader">Submit</span>
                <div class="spinner-border spinner-border-sm text-light" role="status" v-else>
                  <span class="visually-hidden">Loading...</span>
                </div>
              </button>
            </div>
          </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Schedule Modal -->
</template>

<script>
import { timeInputMixin } from "../../mixins/timeInputMixin";
import { ref } from "vue";
import axios from 'axios';
import { VUE_APP_API_BASE_URL } from "../../config";
import { formatDateTimeStandardWithTime } from "../../utils/util-funcitons";
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
export default {
  mixins: [timeInputMixin],
  props: {
    id: {
      type: String,
      default: 'edit_attendance'
    }
  },
  data() {
    return {
      userData: '',
      scheduleId: '',
      user_schedule_data_id: '',
      loader: false,
     
      startTime: '',
      endTime:'',
      dateFormat: 'dd-MM-yyyy',
      startdateone: currentDateOne,
      reason:'',
      attendanceDetails:''

    };
  },
  mounted() {
    
  },
  methods: {
    
    submit() {
      this.loader = true;
      axios.post(`${VUE_APP_API_BASE_URL}/attendance/edit`, {
        attendance_id: this.attendanceDetails.id,
        first_check_in_time: this.startTime,
        last_check_out_time: this.endTime,
        reason: this.reason
      })
        .then((response) => {
          if (response.data.status) {
            this.$toast.success(response.data.message);
            this.$router.go(0)
          } else {
            this.$toast.error(response.data.message || response.data.errors);
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

    formatDateTime(datetime) {
      if (!datetime) return '';
      return formatDateTimeStandardWithTime(datetime);
    },
    updateValues(record){
      this.attendanceDetails = record;
      this.startTime = this.attendanceDetails.first_check_in_time;
      this.endTime = this.attendanceDetails.last_check_out_time;
      this.reason = this.attendanceDetails.reason;
    },

    convertMinutesToHours(minutes) {
      var num = minutes;
      var hours = (num / 60);
      var rhours = Math.floor(hours);
      var minute = (hours - rhours) * 60;
      var rminutes = Math.round(minute);
      return rhours + ":" + rminutes;
    },
  }
};
</script>

<style scoped>
.top-margin {
  margin-top: 2.2rem !important;
}
</style>
